import { type SelectItem } from "@/utils/dataTypes"
import { LOGO_SIZES, getTokenLogoDisplay } from "@/utils/logo"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useCallback, useContext } from "react"
import TokenListContext from "../context"

const RecentTokenItem = ({ token }: { token: SelectItem }) => {
  const { handleClose, handleTokenSelect, selectedToken } = useContext(TokenListContext)

  const handleClick = useCallback(() => {
    selectedToken?.value === token.value ? handleClose() : handleTokenSelect(token)
  }, [selectedToken, token, handleClose, handleTokenSelect])

  return (
    <Stack
      direction='row'
      alignItems='center'
      className='bg-secondary text-neutral-1000 px-3 py-2 rounded-lg cursor-pointer hover:bg-primary/10'
      gap={1}
      onClick={handleClick}
      data-testid={`recent-token-item-${token.symbol}`}
    >
      <Box>{getTokenLogoDisplay(token.symbol, { logo: token.icon }, LOGO_SIZES.MD)}</Box>
      <Typography className='font-semibold text-sm'>{token.symbol}</Typography>
    </Stack>
  )
}

export default RecentTokenItem
